import { Link } from "react-router-dom";

const stats = [
  { value: "1,286", label: "累计整理线索" },
  { value: "312", label: "已核验条目" },
  { value: "486", label: "长期匿名线人" },
  { value: "26h", label: "平均核验时长" },
];

export default function Hero() {
  return (
    <section className="relative w-full overflow-hidden ink-panel">
      <div className="absolute inset-0 h-full w-full">
        <img
          src="https://readdy.ai/api/search-image?query=empty%20narrow%20city%20alley%20at%20deep%20night%20with%20a%20single%20warm%20street%20lamp%2C%20wet%20pavement%20reflections%2C%20heavy%20shadows%2C%20moody%20cinematic%20editorial%20photography%2C%20dark%20amber%20and%20deep%20brown%20tones%2C%20no%20people&width=1600&height=1000&seq=hero-midnight-alley-2026&orientation=landscape"
          alt="深夜城市街巷中的一盏灯，象征深夜爆料线人的匿名线索入口"
          title="深夜爆料 - 匿名线人投稿入口"
          className="h-full w-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/75 to-foreground-950/95" />
      <div className="noise absolute inset-0 opacity-60" />

      <div className="wrap relative z-10 flex min-h-[560px] w-full flex-col justify-center py-24 md:min-h-[660px] md:py-28">
        <div className="flex items-center gap-3">
          <span className="lamp-pulse flex h-2 w-2 rounded-full bg-accent-400" />
          <span className="eyebrow text-accent-400">LINREN · ANONYMOUS TIP LINE</span>
        </div>

        <h1 className="mt-6 font-heading text-3xl font-black leading-tight text-background-50 md:text-6xl">
          深夜爆料
          <span className="mt-2 block text-xl font-bold text-accent-300 md:text-3xl">
            匿名线人与内部来源的线索入口
          </span>
        </h1>

        <p className="mt-6 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
          我们只做一件事：接收来自线人、知情者与内部来源的匿名投稿，把零散的说法交叉印证、脱敏整理，再按可信等级公开。
          这里不追热点、不编故事，只记录可以被核对的部分。
        </p>

        <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
          <Link
            to="/#submit"
            className="btn-base bg-primary-500 px-6 py-3 text-background-50 hover:bg-primary-600"
          >
            <i className="ri-mic-line text-base" />
            我要匿名投稿
          </Link>
          <Link
            to="/leaks"
            className="btn-base border border-background-50/25 px-6 py-3 text-background-50 hover:bg-background-50/10"
          >
            <i className="ri-folder-open-line text-base" />
            浏览线索库
          </Link>
        </div>

        <dl className="mt-12 grid grid-cols-2 gap-px overflow-hidden rounded-lg border border-background-50/10 bg-background-50/10 md:mt-16 md:grid-cols-4">
          {stats.map((item) => (
            <div key={item.label} className="bg-foreground-950/60 px-5 py-5 backdrop-blur">
              <dt className="font-heading text-2xl font-bold text-background-50 md:text-3xl">
                {item.value}
              </dt>
              <dd className="mt-1 font-label text-xs text-background-400">{item.label}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}